import { useMutation } from '@tanstack/react-query'
import axios, { AxiosError } from 'axios'

import { ENV } from '@/common/constants/env'
import { ApiError } from '@/lib/axios'

type ChangePasswordRequest = {
  currentPassword: string
  newPassword: string
}

async function changePassword(
  id: string,
  { currentPassword, newPassword }: ChangePasswordRequest,
  token: string,
) {
  const axiosWithCustomToken = axios.create({
    baseURL: ENV.VITE_BACKEND_URL,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })

  const { data } = await axiosWithCustomToken.post(
    `/application-account-users/change-password/${id}`,
    {
      passCurrent: currentPassword,
      passSvs: newPassword,
    },
  )
  return data
}

export function useChangePassword() {
  const { mutateAsync, isPending } = useMutation<
    unknown,
    AxiosError<ApiError>,
    { id: string; passwords: ChangePasswordRequest; token: string }
  >({
    mutationKey: ['/application-account-users/change-password'],
    mutationFn: ({ id, passwords, token }) =>
      changePassword(id, passwords, token),
  })

  const handleChangePassword = async (
    id: string,
    passwords: ChangePasswordRequest,
    token: string,
  ) => {
    return mutateAsync({ id, passwords, token })
  }

  return { handleChangePassword, isChangingPassword: isPending }
}
